import styled from 'styled-components';

export const ContainerStyled = styled.div`
  overflow: hidden;

  display: grid;
  grid-template: min-content min-content 1fr / 1fr;
  gap: 8px;
`;

export const WrapperStyled = styled.div`
  padding: 24px 0;
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

export const DividerStyled = styled.div`
  border-bottom: 2px solid var(--ds-border, var(--ds-fb-border));
  border-radius: 8px;
`;
